<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='onSave') 保存
    template(v-if='getPageType() !== "create"')
      el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit' @click="preview('ja')") プレビュー
    //- form(:action='getAPI(true) + "?lang=en"' method='post' target='_blank')
    //-   input(type='hidden' :value='getJsonFormData()' name='json')
    //-   el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit') プレビュー[英語]
    //- form(:action='getAPI(true) + "?lang=ja"' method='post' target='_blank')
    //-   input(type='hidden' :value='getJsonFormData()' name='json')
    //-   el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit') プレビュー[日本語]
    el-button(v-if='getPageType !== "create"' size='mini' type='danger' icon='el-icon-delete' @click='onDelete') 削除
    //- .options__func
    //-   el-button(type='success' size='mini' icon='el-icon-sort' @click='showModal("sortelement")' :disabled='hasAddItems') チャプター順序変更
    //-   el-button(type='primary' size='mini' icon='el-icon-plus' @click='showModal("addelement")') チャプター要素追加
  .contents-container
    el-form.c-form(ref='form', :model='form', v-loading='LOADING')
      header.c-form__header
        h1 必須項目
      .c-form__body(v-if='dataloaded')
        section.c-form__item
          header.c-form__item__header.--c.--top
            h1 タイトル
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.title.ja' placeholder='タイトルを入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.title.en' placeholder='タイトルを入力してください')
        section.c-form__item
          header.c-form__item__header.--c.--top
            h1 クライアント名
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.client.ja' placeholder='クライアント名を入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.client.en' placeholder='クライアント名を入力してください')
        section.c-form__item
          header.c-form__item__header.--c.--top
            h1 説明文（400文字推奨）
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.main_description.ja' placeholder='説明文を入力してください' type='textarea' :rows='10')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.main_description.en' placeholder='説明文を入力してください' type='textarea' :rows='10')
              el-col(:span='24')
                p.caption.u-margin__bottom--m マークアップタグを利用できます。矢印リンクを使用する場合は、.arrow クラスを付与してください。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;

        section.c-form__item
          header.c-form__item__header
            h1 案件タイプ
          .c-form__item__body
            el-form-item
              el-select(v-model='form.project_type')
                el-option(v-for='item in OPTIONS.stories_project_type', :key='item.id', :label='item.name', :value='item.id')

        section.c-form__item
          header.c-form__item__header
            h1 メディアタイプ
          .c-form__item__body
            el-form-item
              el-checkbox-group(v-model='form.tag', :min='1')
                el-checkbox(v-for='tag in OPTIONS.stories_tag', :label='tag.id', :key='tag.id') {{tag.name}}

        //- section.c-form__item
        //-   header.c-form__item__header
        //-     h1 テキストカラー
        //-   .c-form__item__body
        //-     el-form-item
        //-       el-color-picker(v-model='form.textcolor' :predefine='predefineColors')
        //-       p.caption
        //-        | サムネイルなど画像の上にテキストが表示される場合のテキストカラーを設定します。
        //-        | 未設定の場合はデフォルトカラーが使用されます。
        section.c-form__item
          header.c-form__item__header
            h1 ID
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item
                  el-input(v-model='form.key' placeholder='IDを入力してください')
                  p.caption URLに使われます。半角英数記号(_)のキャメルケースで入力してください。(e.g: emprire_of_the_sun)
        section.c-form__item
          header.c-form__item__header
            h1 冒頭 タイトル&テキスト
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.description[0].title.ja' placeholder='タイトルを入力してください')
                  el-input(v-model='form.description[0].body.ja' placeholder='テキストを入力してください' type='textarea' :rows='5')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.description[0].title.en' placeholder='タイトルを入力してください')
                  el-input(v-model='form.description[0].body.en' placeholder='テキストを入力してください' type='textarea' :rows='5')
              el-col(:span='24')
                p.caption.u-margin__bottom--m マークアップタグを利用できます。矢印リンクを使用する場合は、.arrow クラスを付与してください。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;

            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.description[1].title.ja' placeholder='タイトルを入力してください')
                  el-input(v-model='form.description[1].body.ja' placeholder='テキストを入力してください' type='textarea' :rows='5')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.description[1].title.en' placeholder='タイトルを入力してください')
                  el-input(v-model='form.description[1].body.en' placeholder='テキストを入力してください' type='textarea' :rows='5')
              el-col(:span='24')
                p.caption.u-margin__bottom--m マークアップタグを利用できます。矢印リンクを使用する場合は、.arrow クラスを付与してください。
                  br
                  code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;
        //- section.c-form__item
        //-   header.c-form__item__header
        //-     h1 冒頭 タイトル&テキスト 罫線エリア
        //-   .c-form__item__body
        //-     el-row(:gutter='20')
        //-       el-col(:span='12')
        //-         el-form-item(label='日本語')
        //-           el-input(v-model='form.description[2].title.ja' placeholder='タイトルを入力してください')
        //-           el-input(v-model='form.description[2].body.ja' placeholder='テキストを入力してください' type='textarea' :rows='5')
        //-       el-col(:span='12')
        //-         el-form-item(label='英語')
        //-           el-input(v-model='form.description[2].title.en' placeholder='タイトルを入力してください')
        //-           el-input(v-model='form.description[2].body.en' placeholder='テキストを入力してください' type='textarea' :rows='5')
        section.c-form__item
          header.c-form__item__header
            h1 ステータス
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  el-select(v-model='form.status')
                    el-option(v-for='item in OPTIONS.status', :key='item.value', :label='item.label', :value='item.value')

        section.c-form__item
          header.c-form__item__header
            h1 日時
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  el-date-picker(v-model='form.date', value-format='yyyy-MM-dd', type='date', placeholder='年月日を設定してください')

        section.c-form__item
          header.c-form__item__header
            h1 メイン画像（高さ固定 全幅で表示）
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item
                  upload-single(:form='form' datakey='main_image' ratio='16_9')

        section.c-form__item
          header.c-form__item__header.--c.--top
            h1 クレジット
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.credit.ja' placeholder='クレジットを入力してください' type='textarea' :rows='10')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.credit.en' placeholder='クレジットを入力してください' type='textarea' :rows='10')

        //- section.c-form__item
        //-   header.c-form__item__header
        //-     h1 サムネイル画像
        //-   .c-form__item__body
        //-     el-row(:gutter='20')
        //-       el-col(:span='12')
        //-         el-form-item
        //-           upload-single(:form='form' datakey='thumbnail' type='thumb' ratio='960_351')
        //-       el-col(:span='7')
        //-         el-form-item
        //-           upload-single(:form='form' datakey='thumbnail' type='thumb' ratio='1_1')
      header.c-form__header.c-form__header--opt
        h1 チャプター
        .func
          //- el-button(type='success' size='mini' icon='el-icon-sort' @click='showModal("sortelement")' :disabled='hasAddItems') チャプター順序変更
          el-button(type='primary' size='mini' icon='el-icon-plus' @click='addChapters') チャプター追加
      .c-form__body
        section.c-form__item(v-for='(element, index) in form.chapters' :key='`chapters-${index}`')
          header.c-form__item__header
            h1 【チャプター {{index + 1}}】 タイトル
            i.icon.el-icon-delete(@click='deleteChapterItem(index)')
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.chapters[index].title.ja' placeholder='タイトルを入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.chapters[index].title.en' placeholder='タイトルを入力してください')
          section.c-form__item
            header.c-form__item__header
              h1 【チャプター {{index + 1}}】 追加要素
              .func
                el-button(type='primary' size='mini' icon='el-icon-plus' @click='showModal("addelement", index)') チャプター追加要素追加
            section.c-form__item(v-for='(element2, index2) in form.chapters[index].additional_items' :key='`chapters-${index}-${index2}`')
              template(v-if='element2.item_type === "video"')
                header.c-form__item__header
                  h1 動画
                  i.icon.el-icon-delete(@click='deleteAddItem(index, index2)')
                .c-form__item__body
                  el-row(:gutter='20')
                    el-col(:span='12')
                      el-form-item
                        el-input(v-model='form.chapters[index].additional_items[index2].video_uri' placeholder='動画サイトのURLを入力してください')
                        p.caption サムネイルは動画サイトに設定したものが使用されます。
              //- template(v-else-if='element2.item_type === "image"')
              //-   header.c-form__item__header
              //-     h1 単数画像
              //-     i.icon.el-icon-delete(@click='deleteAddItem(index, index2)')
              //-   .c-form__item__body
              //-     el-row(:gutter='20')
              //-       el-col(:span='12')
              //-         el-form-item
              //-           upload-single2(:form='form' :chapter_index='index' :add_item_index='index2')
              template(v-else-if='element2.item_type === "images"')
                header.c-form__item__header
                  h1 画像
                  i.icon.el-icon-delete(@click='deleteAddItem(index, index2)')
                .c-form__item__body
                  upload-multi(:form='form' :chapter_index='index' :add_item_index='index2')
              template(v-else-if='element2.item_type === "titleAndText"')
                header.c-form__item__header
                  h1 タイトル&テキスト
                  i.icon.el-icon-delete(@click='deleteAddItem(index, index2)')
                .c-form__item__body
                  el-row(:gutter='20')
                    el-col(:span='12')
                      el-form-item(label='日本語')
                        el-input(v-model='form.chapters[index].additional_items[index2].title.ja' placeholder='タイトルを入力してください')
                        el-input(v-model='form.chapters[index].additional_items[index2].body.ja' placeholder='テキストを入力してください' type='textarea' :rows='20')
                    el-col(:span='12')
                      el-form-item(label='英語')
                        el-input(v-model='form.chapters[index].additional_items[index2].title.en' placeholder='タイトルを入力してください')
                        el-input(v-model='form.chapters[index].additional_items[index2].body.en' placeholder='テキストを入力してください' type='textarea' :rows='20')
                    el-col(:span='24')
                      p.caption.u-margin__bottom--m マークアップタグを利用できます。矢印リンクを使用する場合は、.arrow クラスを付与してください。
                        br
                        code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;
              template(v-else-if='element2.item_type === "text"')
                header.c-form__item__header
                  h1 テキスト
                  i.icon.el-icon-delete(@click='deleteAddItem(index, index2)')
                .c-form__item__body
                  el-row(:gutter='20')
                    el-col(:span='12')
                      el-form-item(label='日本語')
                        el-input(v-model='form.chapters[index].additional_items[index2].body.ja' placeholder='テキストを入力してください' type='textarea' :rows='20')
                    el-col(:span='12')
                      el-form-item(label='英語')
                        el-input(v-model='form.chapters[index].additional_items[index2].body.en' placeholder='テキストを入力してください' type='textarea' :rows='20')
                    el-col(:span='24')
                      p.caption.u-margin__bottom--m マークアップタグを利用できます。矢印リンクを使用する場合は、.arrow クラスを付与してください。
                        br
                        code 例：&lt;a href="https://www.google.com/" class="arrow"&gt;Google&lt;/a&gt;

  template(v-if='!LOADING')
    modal-add-element(:visible='modal.addelement.visible' @hideModal='hideModal')
    //- modal-sort-element(:visible='modal.sortelement.visible' @hideModal='hideModal' :list='form.additional_items')
</template>

<script type='text/javascript'>
import form from '@/mixins/form'
import Sticky from '@/components/Element/Sticky'
import UploadSingle from '@/components/Element/Upload/Single'
import UploadSingle2 from '@/components/Element/Upload/SingleForStories'
import UploadMulti from '@/components/Element/Upload/MultiForStories'
import ModalAddElement from '@/components/Element/Modal/AddStoriesElement'
import ModalSortElement from '@/components/Element/Modal/SortElement'
export default {
  name: 'PagesStoriesDetail',
  mixins: [form],
  data () {
    return {
      modal: {
        addelement: {
          visible: false,
          index: null
        },
        sortelement: {
          visible: false
        }
      },
      initialForm: null, // 初期値
      form: {
        id: null,
        key: null,
        date: null,
        tag: [],
        project_type: 1,
        client: {
          ja: null,
          en: null
        },
        credit: {
          ja: null,
          en: null
        },
        main_description: {
          ja: null,
          en: null
        },
        description: [
          {
            title: {
              ja: 'Mission',
              en: 'Mission'
            },
            body: {
              ja: null,
              en: null
            }
          },
          {
            title: {
              ja: 'Approach',
              en: 'Approach'
            },
            body: {
              ja: null,
              en: null
            }
          },
          {
            title: {
              ja: 'Director’s Note',
              en: 'Director’s Note'
            },
            body: {
              ja: null,
              en: null
            }
          }
        ],
        status: 0,
        title: {
          ja: null,
          en: null
        },
        main_image: {
          id: null,
          uri: null
        },
        thumbnail: {
          square: null,
          rectangle: null
        },
        chapters: [
          {
            title: {
              ja: null,
              en: null
            },
            additional_items: []
          }
        ]
      }
    }
  },
  methods: {
    /**
     * @param {String} key
     */
    showModal (key, index) {
      this.modal[key].visible = true
      this.modal[key].index = index
    },
    /**
     * @param {String} key
     * @param {Object} data
     */
    hideModal (key, data) {
      this.modal[key].visible = false
      if (key === 'addelement' && data) {
        this.form.chapters[this.modal[key].index].additional_items.push(data)
      }
      this.modal[key].index = null
    },
    addChapters () {
      this.form.chapters.push({
        title: {
          ja: null,
          en: null
        },
        additional_items: []
      })
    },
    deleteChapterItem (index) {
      this.$confirm('このチャプターを削除しますか？', 'Warning', {
        confirmButtonText: '削除する',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.form.chapters.splice(index, 1)
      })
    },
    deleteAddItem (chapterIndex, addItemIndex) {
      this.$confirm('この要素を削除しますか？', 'Warning', {
        confirmButtonText: '削除する',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.form.chapters[chapterIndex].additional_items.splice(addItemIndex, 1)
      })
    },
    hasUnsavedChanges () {
      return JSON.stringify(this.form) !== JSON.stringify(this.initialForm)
    },
    preview (lang) {
      const openPreviewWindow = (lang) => {
        const path = lang === 'ja' ? '' : 'en/'
        const currentHost = location.hostname

        let previewBaseUrl

        if (currentHost === 'w0w-2024-cms.s2factory.co.jp') {
          previewBaseUrl = 'https://w0w-2024-www.s2factory.co.jp'
        } else if (currentHost === 'cms.w0w.co.jp') {
          previewBaseUrl = 'https://www.w0w.co.jp'
        } else {
          // デフォルト（予期しないホストの場合）
          previewBaseUrl = 'https://www.w0w.co.jp'
        }

        const url = `${previewBaseUrl}/${path}draft/stories/${this.form.key}`
        window.open(url, '_blank')
      }
      if (this.hasUnsavedChanges()) {
        this.$confirm('未保存の変更があります。保存せずにプレビューしますか？', '確認', {
          confirmButtonText: 'はい',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(() => {
          openPreviewWindow(lang)
        }).catch(() => {
        // キャンセルされた場合は何もしない
        })
      } else {
        openPreviewWindow(lang)
      }
    }

  },
  computed: {
    /**
     * @return {Boolean}
     */
    hasAddItems () {
      return !(this.form.chapters.length > 0)
    }
  },
  created () {
    this.getStoriesType()
    this.init()
  },
  watch: {
    'form.description': function (nv, ov) {
      if (nv.length !== 3) {
        this.form.description = ov
      }
    }
  },
  components: {
    Sticky,
    UploadSingle,
    UploadMulti,
    ModalAddElement,
    ModalSortElement,
    UploadSingle2
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Stories/Detail/index.vue